<template>
    <!-- 关于我们 -->
    <div>
        <myheader :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <div class="h">这里象征着<br/>我们的态度和能力</div>
                <div class="p">
                    甘肃有众信息科技有限公司，核心技术团队有着超过13年的技术沉淀，在APP、小程序等移动应用，网站、手机网站等B/S架构系统开发上积累了丰富的开发经验，保障了能够全方位为客户提供可拓展的技术支持。
                    <br/><br/>
                    经过近年的运作目前有众科技已经拥有了一支开拓进取，技术齐备的开发和管理团队，包括项目策划、UI设计、前端交互、系统编程等，建立了完善的开发服务体系。我们始终以客户需求为发展方向，以客户满意为最终目标，一如既往地为客户提供及时周到的技术支持服务。</div>
                <div class="moreboxmax">
                    <div class="a a1" @click="kefuclick"><i>在线咨询</i></div> 
                      <div class="a a2" @click="baojia">获取报价</div>
                </div>
            </div>
        </div>
        <div class="aboutboxmaxicon wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
            <div class="li"><img src="../assets/images/v1.png" alt=""><i>python</i></div>
            <div class="li"><img src="../assets/images/v2.png" alt=""><i>java</i></div>
            <div class="li"><img src="../assets/images/v3.png" alt=""><i>php</i></div>
            <div class="li"><img src="../assets/images/v4.png" alt=""><i>vue</i></div>
            <div class="li"><img src="../assets/images/v5.png" alt=""><i>sketch</i></div>
            <div class="li"><img src="../assets/images/v6.png" alt=""><i>蓝湖</i></div>
        </div>
        <div class="aboutboxmaxone wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
            <div class="li"><img src="../assets/images/v7.png" alt=""></div>
            <div class="li"><img src="../assets/images/v8.png" alt=""></div>
            <div class="li"><img src="../assets/images/v9.png" alt=""></div>
        </div>
        <div class="aboutboxmaxtwo wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                <div class="tit">通过自己的专业眼光<br/>始终为客户思考</div>
                <div class="list">
                    <div class="li" v-for="(item,index) in aboutwo" :key="index">
                        <div class="h">{{item.name}}</div>
                        <div class="p">{{item.text}}</div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="aboutboxmaxthree">
            <div class="tit wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">受到了知名客户的信任</div>
            <div class="list wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="li"><img src="../assets/images/a1.png" alt=""></div>
                <div class="li"><img src="../assets/images/a2.png" alt=""></div>
                <div class="li"><img src="../assets/images/a3.png" alt=""></div>
                <div class="li"><img src="../assets/images/a4.png" alt=""></div>
                <div class="li"><img src="../assets/images/a5.png" alt=""></div>
                <div class="li"><img src="../assets/images/a6.png" alt=""></div>
            </div>
        </div>
        <div class="aboutboxmaxfour wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk">
                <div class="img">
                    <img src="../assets/17.png" alt="" class="img1">
                    <img src="../assets/16.png" alt="" class="img2">
                </div>
                <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                    <div class="tit">愿景&文化</div>
                    <div class="min">
                        <div class="li" v-for="(item,index) in aboufour" :key="index">
                            <div class="h">{{item.name}}</div>
                            <div class="p">{{item.text}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aboutboxmaxfive wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                <div class="text">
                    <div class="h">工作</div>
                    <div class="p">投入你一生都引以为荣的工作<br/>在这里绽放你的光芒</div>
                    <div class="medli">
                        <img src="../assets/img/icon12.png" alt="">
                        <div>kefu@gsyzkj.com</div>
                    </div>
                </div>
                <div class="list">
                    <div class="li" v-for="(item,index) in aboufive" :key="index">
                        <div class="wk">
                            <div class="m"><img :src="item.imgs" alt=""></div>
                            <div class="h">{{item.name}}</div>
                            <div class="p">{{item.text}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aboutboxmaxsix">
            <div class="mk">
                <div class="tit wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="h">动态</div>
                    <div class="p">关注我们，获取最新消息</div>
                </div>
                <div class="list wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="li" v-for="(item,index) in newslist" :key="index" @click="imgcclick(item.id)">
                        <div class="h">{{item.title}}</div>
                        <div class="p">{{item.brief}}</div>
                        <div class="t">{{ parseTime(item.addtime, '{y}/{m}/{d}') }}</div>
                    </div>
                </div>
                <div class="more wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><i @click="morenaews">查看更多></i></div>
            </div>
        </div>
        <!--  -->
        <myfooter></myfooter>
        <!--  -->
        <upsform :upunm="baoMessage" @updateEvent="handleUpdate"></upsform>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    import upsform from './upform.vue'
    
    export default {
        data() {
            return {
                aboutwo: [
                    {
                        name: '作业规范',
                        text: '团队遵循国际通用的CMM项目管理规范进行项目管理,开发全过程采用RUP迭代原型法进行控制。'
                    },
                    {
                        name: '设计标准',
                        text: '我们拥有高素质的设计团队，完全采用符合W3C规范标准的页面布局技术，为客户量身设计不同风格、不同需求的产品。'
                    },
                    {
                        name: '优质客户',
                        text: '好未来教育、学而思培优、励步英语、乐视集团、敦煌研究院、甘肃省农业农村厅、兰州电信、甘肃合睿律师事务所、达人录 、金融法务研究网、依曼琪、兰州金石资源环境 、零一科技、甘肃联通等'
                    },
                    {
                        name: '人员领先',
                        text: '具备专业的策划师，设计师，程序员，优化员，营销师等各类专业人员，平均从业经验达到5年以上、其中多名技术人员经验在8年以上。'
                    }
                ],
                aboufour: [
                    {
                        name: '自由与被信任',
                        text: '每个人都要笔直的一个很高的平台上向后倒下，而其他人则伸出双手保护他。如果你对别人不信任，害怕会摔倒，那么这个游戏就进行不下去，每个人都希望可以和他人相互信任，否则就会缺乏安全感。而我们要别人信任，首先得要自己成为一个值得被信任的人。'
                    },
                    {
                        name: '拥抱技术',
                        text: '我们的行业一直在发展，而技术能力取决于我们的学习状态\n因此，我们努力保持灵活性\n适应性并时刻为明天的变化做好准备。'
                    },
                    {
                        name: '有以善处  众擎易举',
                        text: '通过自己的专业眼光，为客户提供各类解决方案，始终为客户思考，一个人能走多远，取决于与谁同行，有众科技团队是一个富有理想和激情的团队，也是一个技术专业化、管理人性化、创新性和学习型的优秀团队。'
                    }
                ],
                aboufive: [
                    {
                        imgs: require('../assets/img/UIs.png'),
                        name: '网页/UI 设计',
                        text: '负责网站软件界面设计、移动App界面设计,及界面相关图片图标、动画等制作工作。'
                    },
                    {
                        imgs: require('../assets/img/php.png'),
                        name: 'PHP开发',
                        text: '根据设计任务及需求进行后台系统的二次开发，包括原有系统的修改、功能模块的添加等'
                    },
                    {
                        imgs: require('../assets/img/img14s.png'),
                        name: '前端开发',
                        text: '根据开发文档以及公司规范，独立完成模块的编码；协助完成项目的上线工作，对项目上线提供支持'
                    },
                    {
                        imgs: require('../assets/img/ans.png'),
                        name: '安卓开发',
                        text: '有扎实的JAVA基础，3年以上Android开发经验，熟悉开发工具、软件调试方法，熟悉软件发布流程'
                    }
                ],
                abousix: [
                    {
                        name: '小程序大火 如何用小程序进行电商创业',
                        text: '通过SEO优化获取网站目标流量并提高客户转化，真正的SEO是协助搜索引擎高效率抓取、及时更新、提升排序质量并让目标结果能解决用户的实际需求...',
                        time: '2021/12/23'
                    },
                    {
                        name: '搜索引擎优化原理',
                        text: '通过SEO优化获取网站目标流量并提高客户转化，真正的SEO是协助搜索引擎高效率抓取、及时更新、提升排序质量并让目标结果能解决用户的实际需求...',
                        time: '2021/12/23'
                    }
                ],
                parentMessage: 4,
                baoMessage: false,
                querInfo: {
                    classifyid: '',
                    pageNum: 1,
                    pageSize: 2
                },
                newslist: []
            }
        },
        created() {
            this.getNewslist()
        },
        methods: {
            handleUpdate(updatedValue) {
                this.baoMessage = updatedValue; // 更新父组件的Prop值
            },
            baojia() {
                this.baoMessage = true;
            },
            async getNewslist(){
                var url = `/api/news/list?classifyid=${this.querInfo.classifyid}&pageNum=${this.querInfo.pageNum}&pageSize=${this.querInfo.pageSize}`
                const { data: res } = await this.$http.post(url)
                
                this.newslist = res.data.rows
            },
            imgcclick(id){
                const { href } = this.$router.resolve({
                    path: '/newsdata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            },
            morenaews(){
                this.$router.push('/news').catch(()=>{ })
                window.scrollTo(0,0);
            },
            // https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D
            kefuclick(){
                const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
                // window.location.href = url;
                window.open(url)
            },
            parseTime(time, pattern) {
                  if (arguments.length === 0 || !time) {
                    return null
                  }
                  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
                  let date
                  if (typeof time === 'object') {
                    date = time
                  } else {
                    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                      time = parseInt(time)
                    } else if (typeof time === 'string') {
                      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
                    }
                    if ((typeof time === 'number') && (time.toString().length === 10)) {
                      time = time * 1000
                    }
                    date = new Date(time)
                  }
                  const formatObj = {
                    y: date.getFullYear(),
                    m: date.getMonth() + 1,
                    d: date.getDate(),
                    h: date.getHours(),
                    i: date.getMinutes(),
                    s: date.getSeconds(),
                    a: date.getDay()
                  }
                  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
                    let value = formatObj[key]
                    // Note: getDay() returns 0 on Sunday
                    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
                    if (result.length > 0 && value < 10) {
                      value = '0' + value
                    }
                    return value || 0
                  })
                  return time_str
            }
        },
        components: {
        	myfooter, myheader, upsform
        }
    }
</script>

<style>
    
    .aboutopcomm .mk{ padding: 1.3rem 2.2rem 1.1rem 2.7rem;}
    .aboutopcomm .h{ text-align: left;}
    .aboutopcomm .p{ text-align: left;}
    
    .aboutboxmaxicon{ display: flex; justify-content: center; padding-top: 1rem;}
    .aboutboxmaxicon .li{ margin: 0 0.45rem; transition: all 0.5s;}
    .aboutboxmaxicon .li:hover{ transform: translateY(-0.08rem);}
    .aboutboxmaxicon .li img{ display: block; height: 0.6rem; margin: auto;}
    .aboutboxmaxicon .li i{ display: block; text-align: center; font-size: 0.14rem; line-height: 0.18rem; margin-top: 0.08rem; color: #6A6A6A;}
    .aboutboxmaxone{ padding: 1rem 0;}
    

</style>
